import { Route, Routes } from 'react-router';

import AddNewAnnouncement from './AddNewAnnouncement';
import AnnouncementEdit from './AnnouncementEdit';
import AnnouncementList from './AnnouncementList';

function AnnouncementModule() {
  return (
    <Routes>
      <Route index element={<AnnouncementList />} />
      <Route path="add" element={<AddNewAnnouncement />} />
      <Route path=":id" element={<AnnouncementEdit />} />
    </Routes>
  );
}

export default AnnouncementModule;
